export default __webpack_public_path__ + "static/media/arrow-right.25213201.svg";